<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card colClasses="xs12">
					<v-form
						@submit="onSubmit"
						ref="storeFormElement"
						v-model="storeForm.valid"
					>
						<v-container>
							<v-layout row wrap>
								<!-- TELEGRAM SECTION START -->
								<v-flex xs12 align-self-center class="relative">
									<h3 class="no-margin-title">
										{{ $t("message.telegramConnection") }}
									</h3>
									<v-tooltip top>
										<template v-slot:activator="{ on }">
											<a
												class="v-btn v-btn--floating v-btn--router v-btn--small theme--dark warning bot-help-button"
												href="https://docs.microsoft.com/es-mx/azure/bot-service/bot-service-channel-connect-telegram?view=azure-bot-service-4.0"
												target="_blank"
												v-on="on"
											>
												<v-icon dark>zmdi-help</v-icon>
											</a>
										</template>
										<span>{{ $t("message.howCreateBot") }}</span>
									</v-tooltip>
								</v-flex>
								<v-flex xs12 sm10 align-self-center>
									<v-text-field
										prefix="@"
										:label="$t('message.storeBotName')"
										data-vv-name="storeBotName"
										v-model="storeForm.telegramUserBot"
										v-validate="'min:4|max:30|'"
										:error-messages="errors.collect('storeTelegramUser')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm2 v-if="storeForm.telegramUserBot">
									<div class="qr-container">
										<a
											target="_blank"
											:href="`https://t.me/${storeForm.telegramUserBot}`"
										>
											<qr-code
												id="telegram-qr"
												:value="`https://t.me/${storeForm.telegramUserBot}`"
												:options="{ width: qrWidth }"
											></qr-code>
										</a>
										<v-btn @click="handleQrDownload('telegram')" outline
											>Guardar QR</v-btn
										>
									</div>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										:error-messages="errors.collect('telegramBotToken')"
										data-vv-name="telegramBotToken"
										:label="$t('message.token')"
										v-model="storeForm.telegramBotToken"
										v-validate="{
											regex: /[0-9]{9}:[a-zA-Z0-9_-]{35}/,
										}"
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.primaryUserAdministrator')"
										prefix="@"
										v-model="storeForm.telegramAdmin"
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.secondaryUserAdministrator')"
										prefix="@"
										v-model="storeForm.telegramAlternativeAdmin"
									></v-text-field>
								</v-flex>
							</v-layout>
							<v-layout justify-end row>
								<!-- <router-link to="/dashboard">
                  <v-btn outline color="error">{{ $t('message.close') }}</v-btn>
                </router-link> -->
								<v-btn outline @click="onSubmit" color="primary">{{
									$t("message.save")
								}}</v-btn>
							</v-layout>
							<v-layout row wrap> </v-layout>
							<!-- TELEGRAM SECTION END -->
						</v-container>
					</v-form>
				</app-card>
			</v-layout>
		</v-container>
		<notifications
			group="updateStore"
			width="350px"
			position="top right"
			animation-type="velocity"
		/>
	</div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { CHECK_TOKEN_TELEGRAM } from "../../store/modules/telegramBot/actions.type";
import {
	GET_STORE_USER_AUTH,
	UPDATE_STORE,
} from "../../store/modules/storeModule/actions.type";

export default {
	data: () => {
		return {
			storeForm: {
				valid: false,
				hasDelivery: false,
				hasManualRate: false,
				name: "",
				image: null,
				web_store: "",
				telegramUserBot: "",
				dollarPercentage: 0,
				dollarPrice: 0,
				description: "",
				address: "",
				state: "",
				city: "",
				phone: "",
				country: "Venezuela",
				lng: null,
				lat: null,
				telegramAdmin: null,
				telegramAlternativeAdmin: null,
				telegramBotToken: null,
				links: [
					{
						id: "asd",
						name: "",
						description: "",
						url: "",
					},
				],
			},
			isLoading: false,
			isCreate: false,
			qrWidth: 120,
		};
	},
	computed: {
		...mapGetters({ store: "store" }),
	},
	mounted() {
		this.getUserStore();
	},
	methods: {
		async updateQrWidth() {
			if (this.qrWidth === 1080) {
				this.qrWidth = 140;
			} else {
				this.qrWidth = 1080;
			}
		},
		async handleQrDownload(type) {
			await this.updateQrWidth();
			let link = document.createElement("a");
			link.download = type + "store.png";
			link.href = document.getElementById(`${type}-qr`).toDataURL();
			link.click();
			this.updateQrWidth();
		},
		onSubmit() {
			this.$validator
				.validateAll()
				.then((res) => {
					if (res) {
						let storeData = {
							id: this.store.id,
							telegram_user_bot: this.storeForm.telegramUserBot,
							telegram_admin_users: [
								this.storeForm.telegramAdmin,
								this.storeForm.telegramAlternativeAdmin,
							],
						};
						if (
							this.storeForm.telegramBotToken &&
							this.storeForm.telegramBotToken.trim() !== ""
						) {
							storeData["telegram_bot_token"] = this.storeForm.telegramBotToken;
						}

						this.$store.dispatch(UPDATE_STORE, storeData);
						// .then((res) => {
						// 	if (res) {
						// 		setTimeout(() => {
						// 			this.$router.push("/dashboard");
						// 		}, 2000);
						// 	}
						// });
					}
				})
				.catch((err) => {
					Vue.notify({
						group: "loggedIn",
						type: "error",
						text: err.message,
					});
				});
		},
		getUserStore() {
			// if (!this.store) {
			this.$store.dispatch(GET_STORE_USER_AUTH).then((res) => {
				// console.log('getUserStore', res);
				this.storeForm.id = res.id;
				this.storeForm.name = res.name;
				this.storeForm.telegramUserBot = res.telegram_user_bot;
				this.storeForm.dollarPercentage = res.dollar_percent;
				this.storeForm.dollarPrice = res.dollar_price;
				this.storeForm.description = res.description;
				this.storeForm.web_store = res.web_store;
				this.storeForm.currentImage = res.image?.url;
				if (res.address) {
					this.storeForm.city = res.address.city;
					this.storeForm.state = res.address.state;
					this.storeForm.address = res.address.street_address;
					this.storeForm.phone = res.address.phone;
				}
				this.storeForm.links = res.links;
				this.storeForm.lng = res.longitude;
				this.storeForm.lat = res.latitude;
				this.storeForm.telegramBotToken = res["telegram_bot_token"];
				this.storeForm.hasDelivery = res.has_delivery;
				this.storeForm.hasManualRate = res.dollar_price ? true : false;
				//this.storeForm.telegramUser = res['telegram_admin']
				if (res["telegram_admin"].length) {
					if (res["telegram_admin"][0]) {
						this.storeForm.telegramAdmin =
							res["telegram_admin"][0].telegram_user;
					}
					if (res["telegram_admin"][1]) {
						this.storeForm.telegramAlternativeAdmin =
							res["telegram_admin"][1].telegram_user;
					}
				}
			});
		},
		checkToken() {
			this.$store
				.dispatch(CHECK_TOKEN_TELEGRAM, {
					telegramBotToken: this.storeForm.telegramBotToken,
				})
				.then((res) => {
					if (res.status) {
						this.$notify({
							group: "loggedIn",
							type: "success",
							text: res.message,
						});
					} else {
						this.$notify({
							group: "loggedIn",
							type: "error",
							text: res.message,
						});
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style scoped>
.store-image {
	max-width: 100%;
	width: 250px;
	height: auto;
	margin: 0 auto;
	cursor: pointer;
}
.link-container {
	border: 1px solid #e6e6e6;
}
.qr-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.no-margin-title {
	margin: 0;
}
.bot-help-button {
	position: absolute;
	right: 0;
	top: 10%;
}
@media (max-width: 325px) {
	.bot-help-button {
		position: absolute;
		right: 15px;
		top: 5px;
	}
}
</style>
